<template>
    <router-link to="/video" tag="li"
        ><a
            ><i class="fa fa-video-camera"></i
            ><span>Video Pembelajaran</span></a
        ></router-link
    >
</template>

<script>
export default {
    name: "video-nav",
};
</script>



// WEBPACK FOOTER //
// Navigation.vue?fffb08ec